import React from 'react';

export const euroFormat = (value, fraction = 0) => {
	return new Intl.NumberFormat("ru-RU", {
    style: "currency",
    currency: "EUR",
    maximumFractionDigits: fraction,
  }).format(value);
};
